// Address of a file the app shows or loads (character, action, picture).
// Library files are paths on the API ("assets/StaticCharacterJson/..."); a file that already has a
// full address (for example a character served by this React app from public/) is used as it is.
export function assetUrl(apiBaseURL, filePath) {
  if (!filePath) return filePath;
  const p = String(filePath);
  if (/^(https?:|data:|blob:)/i.test(p)) return p;
  return String(apiBaseURL).replace(/\/$/, "") + "/" + p.replace(/^\//, "");
}
